import Pages from "./pages/pages/Pages";



function App() {
  return (
    <div className="App">
        <Pages />
    </div>
  );
}

export default App;
